import { render, staticRenderFns } from "./LanguageDropdown.vue?vue&type=template&id=12138c52"
import script from "./LanguageDropdown.vue?vue&type=script&lang=js"
export * from "./LanguageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12138c52')) {
      api.createRecord('12138c52', component.options)
    } else {
      api.reload('12138c52', component.options)
    }
    module.hot.accept("./LanguageDropdown.vue?vue&type=template&id=12138c52", function () {
      api.rerender('12138c52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/common/LanguageDropdown.vue"
export default component.exports